const FlowWelcome = '/assets/images/flow/welcome.png';
const SignupBanner = '/assets/images/flow/bannerBG.jpg';
const BannerRating = '/assets/images/flow/ratings.png';
const BannerLogin = '/assets/images/flow/bannerLogin.png';
const MedicalStart = '/assets/images/flow/medical_start.jpg';
const MedicalEnd = '/assets/images/flow/medical_end.jpg';
const WeightlossMedicalEndMobile =
  '/assets/images/flow/weightloss_medical_end_mobile.jpg';
const WeightlossMedicalEnd = '/assets/images/flow/weightloss_medical_end.jpg';
const MedicalEndMobile = '/assets/images/flow/medical_end_mobile.jpg';
const MedicalStartMobile = '/assets/images/flow/medical_start_mobile.jpg';
const ErrorIcon = '/assets/icons/flow/error.png';
const SuccessIcon = '/assets/icons/flow/success.png';
const WarningIcon = '/assets/icons/flow/warning.png';
const UploadIcon = '/assets/icons/flow/upload.png';
const AttachmentIcon = '/assets/icons/flow/attachment.png';
const TrashIcon = '/assets/icons/flow/trash.png';
const TreatmentBottle = '/assets/icons/flow/bottle.png';
const NoteYes = '/assets/icons/flow/note-yes.png';
const NoteNo = '/assets/icons/flow/note-no.png';
const TermsIcon = '/assets/icons/flow/terms.png';
const TreatmentEnd = '/assets/images/flow/treatment_end.jpg';
const TreatmentEndMobile = '/assets/images/flow/treatment_end_mobile.jpg';
const PriorityBG = '/assets/images/new/prioBG.png';
const End1 = '/assets/images/new/end1.png';
const End2 = '/assets/images/new/end2.png';
const End3 = '/assets/images/new/end3a.png';
const End4 = '/assets/images/new/end4.png';
const End5 = '/assets/images/new/end5.png';
const End6 = '/assets/images/new/end6.png';
const Careers = '/assets/images/new/careers.png';
const HighlightWeight = '/assets/images/new/diseaseTagImg.png';
const HighlightUMC = '/assets/images/new/highUMC.png';
const HighlightDental = '/assets/images/new/highdental.png';
const HighlightSexual = '/assets/images/new/highsexual.png';
const HighlightMens = '/assets/images/new/highmens.png';
const HighlightWomen = '/assets/images/new/highwomen.png';
const TrustPilotServices = '/assets/images/new/trustpilotServices.png';
const SadSmiley = '/assets/icons/sad-smiley.png';
const WeightProceed = '/assets/images/new/weigh-proceed.jpg';
const WeightProceedMobile = '/assets/images/new/weigh-proceed-mobile.jpg';
const Semaglutide = '/assets/images/flow/sema.png';
const Tirzepatide = '/assets/images/flow/tir.png';
const OralTirzepatide = '/assets/images/flow/oral-t.png';
const OralSemaglutide = '/assets/images/flow/oral-s.png';
const WeightlossBadge = '/assets/images/flow/badge.png';
const WeightBanner = '/assets/images/flow/weightbanner.png';
const WeightBannerMobile = '/assets/images/flow/weightbanner_mobile.png';
const microdosingBannerMobile =
  '/assets/images/new/microdosingBannerMobile.png';
const microdosingBannerDesktop =
  '/assets/images/new/microdosingBannerDesktop.png';
const bgBlur = '/assets/images/v2/bgBlur.png';
//Dashboard
const BgDashboard = '/assets/images/dasboard/bg-home.png';
//ED
const EDHome = '/assets/images/v2/EDhome.png';
const ED2 = '/assets/images/v2/ED2.png';
//const ED2 = '/assets/images/new/Quad.png';
const ED3 = '/assets/images/v2/ED3.png';
const ED4 = '/assets/images/v2/ED4.png';
//const ED_product1 = '/assets/images/v2/EDProd1.png';
const ED_product1 = '/assets/images/v2/Quad3.png';
//const ED_product2 = '/assets/images/v2/EDProd2.png';
const ED_product2 = '/assets/images/v2/Triple.png';
//const ED_product3 = '/assets/images/v2/EDProd3.png';
const ED_product3 = '/assets/images/v2/dailyboost.png';
const ED_product4 = '/assets/images/v2/ED-double.png';
const ED_banner_desktop = '/assets/images/v2/ED-bannerDesk.png';
const ED_banner_mobile = '/assets/images/v2/ED-bannerMobile.png';
const ED_start = '/assets/images/v2/ED-start.png';
const ED_start_mobile = '/assets/images/v2/ED-start_m.png';
const watersplash = '/assets/images/new/watersplash.png';
const bgEdMobile = '/assets/images/v2/bgEdMobile.png';
const bgEdDesktop = '/assets/images/v2/bgEdDesktop.png';
const weightLossOral = '/assets/images/v2/weightLossOral1.png';
const weightLossInjection = '/assets/images/v2/weightLossInjection1.png';
const bottomImgWLMeds = '/assets/images/v2/bottomImgWLMeds.png';
const ED_Featured = '/assets/images/v2/ED_Featured_Home.png';
const WL_Featured = '/assets/images/v2/WL_Featured_Home.png';
const ED_Featured_Desktop = '/assets/images/v2/ED_Featured_Home_Desktop.png';
const WL_Featured_Desktop = '/assets/images/v2/WL_Featured_Home_Desktop.png';
//Checkout
const WL_Checkout1 = '/assets/images/flow/stepImage1.png';
const WL_Checkout2 = '/assets/images/flow/stepImage2.png';
const WL_Checkout3 = '/assets/images/flow/stepImage3.png';
//ARecovery
const AR_hero = '/assets/images/v2/AR_hero.png';
export {
  bgBlur,
  AR_hero,
  WL_Checkout1,
  WL_Checkout2,
  WL_Checkout3,
  EDHome,
  ED_Featured,
  WL_Featured,
  ED_Featured_Desktop,
  WL_Featured_Desktop,
  bottomImgWLMeds,
  weightLossOral,
  weightLossInjection,
  bgEdDesktop,
  bgEdMobile,
  watersplash,
  ED_start_mobile,
  ED_start,
  ED_banner_desktop,
  ED_banner_mobile,
  ED2,
  ED3,
  ED4,
  ED_product1,
  ED_product2,
  ED_product3,
  ED_product4,
  microdosingBannerMobile,
  microdosingBannerDesktop,
  Tirzepatide,
  OralTirzepatide,
  BgDashboard,
  WeightBanner,
  WeightBannerMobile,
  WeightlossBadge,
  Semaglutide,
  OralSemaglutide,
  WeightlossMedicalEndMobile,
  WeightlossMedicalEnd,
  WeightProceed,
  WeightProceedMobile,
  SadSmiley,
  TrustPilotServices,
  HighlightUMC,
  HighlightDental,
  HighlightSexual,
  HighlightMens,
  HighlightWomen,
  HighlightWeight,
  Careers,
  End5,
  End6,
  End1,
  End2,
  End3,
  End4,
  PriorityBG,
  TreatmentEnd,
  TreatmentEndMobile,
  TermsIcon,
  NoteYes,
  NoteNo,
  TreatmentBottle,
  TrashIcon,
  AttachmentIcon,
  FlowWelcome,
  SignupBanner,
  BannerRating,
  BannerLogin,
  MedicalStart,
  MedicalEnd,
  MedicalEndMobile,
  MedicalStartMobile,
  ErrorIcon,
  SuccessIcon,
  WarningIcon,
  UploadIcon,
};
